import styled from 'styled-components';
import { getColor } from 'utils/helpers/styleHelpers';
import { SmsCodeForm } from '../../components/SmsCodeForm/SmsCodeForm';

export const STitle = styled.div`
  font-size: 31px;
  text-align: center;
  color: ${getColor('charcoal')};
  margin-bottom: 46px;
`;

export const SSubTitle = styled.div`
  font-size: 16px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 60px;
`;

export const SSmsCodeForm = styled(SmsCodeForm)`
  margin-bottom: 80px;
`;

export const SDescription = styled.div`
  font-size: 14px;
  text-align: center;
  color: ${getColor('charcoal50')};
  margin-bottom: 28px;
`;

export const SResendCode = styled.div`
  font-size: 18px;
  text-align: center;
  cursor: pointer;
`; 